import React, { useState } from 'react'
import { ErrorMessageContainer } from './Library.styles'
import { Button, PRIMARY_BUTTON, SECONDARY_BUTTON } from '@mds/mds-reactjs-library'
import ReportingEndpoints from '../../Services/ReportingEndpoints'

const LibraryReportRenamePopUp = ({updateReportName, summaryEntry, setShowRenameReportPopup}) => {
  const [reportName, setReportName] = useState(summaryEntry.name)
  const [updateRequestErrorMessage, setUpdateRequestErrorMessage] = useState('')

  const saveName = () => {
    ReportingEndpoints.updateReportRequest(summaryEntry.reportRequestId, {
      reportRequestName : reportName
    })
    .then(() => {
      setShowRenameReportPopup(false);
      setUpdateRequestErrorMessage('');
      updateReportName(summaryEntry.reportRequestId, reportName);
    })
    .catch(() => {
      setUpdateRequestErrorMessage("Something went wrong...");
    })
  }

  return (
        <div className='reportPopupWrapper'>
          <div className='reportPopup'>
            <h1>Name your selection</h1>
            <p>This name will appear in your Library.</p>
            <div style={{margin: '50px 0'}}>
              <input type="text" placeholder='Name' value={reportName} onChange={e => setReportName(e.target.value)} />
              {
                updateRequestErrorMessage &&
                <ErrorMessageContainer>{updateRequestErrorMessage}</ErrorMessageContainer>
              }
            </div>
            <div className="buttons">
              <Button appearance={SECONDARY_BUTTON} onClick={() => { setShowRenameReportPopup(false); setUpdateRequestErrorMessage(''); }}>Cancel</Button>
              <Button appearance={PRIMARY_BUTTON} onClick={saveName}>Save</Button>
            </div>
          </div>
        </div>
  )
}

export default LibraryReportRenamePopUp
